import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LegalStuff/legalStuff__fr-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout },
  seo: {
    ...sharedConfig['fr-FR'].seo,
    title: 'Informations Légales | Documents officiels et conformité Lemonade France',
    metaTitle: 'Informations Légales | Documents officiels et conformité Lemonade France',
    description:
      'Consultez les informations et documents juridiques essentiels liés à l’assurance habitation Lemonade en France, ainsi que nos politiques de conformité.',
  },
  MDXContent: content as DocumentTypes,
};
